import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import Layout from "components/layout/layout";
import { AuthContext } from "providers/userProvider";
import { AuthData } from "types/auth";
import { useContext, useMemo } from "react";
import { moneyFormat } from "utils/money-format";
import { neutral, primary, warm } from "style/color";
import { ReactComponent as GrantVestmentsIcon } from "./../../assets/Icons/Gantvestments.svg";
import React from "react";
import {
  useGetFundBackedGrantVestmentQuery,
  useGetFundBackedGrantVestmentTotalQuery,
} from "hooks/use-services/fund-backed-grant-vestment.service";
import FundBackedGrantVestmentCard from "./fund-backed-grant-vestment-card";
import { FundBackedGrantVestment } from "types/fund-backed-grant-vestment";
import useIntersectionObserver from "hooks/use-services/useIntersectionObserver";
import { useNavigate } from "react-router-dom";
import { GrantVestmentsHomePage } from "constants/pages";
// import { useGetGrantVestmentsQuery } from "hooks/use-services/grant-vestment.service";

const FundBackedGrantVestmentList = () => {
  const navigate = useNavigate();
  const { selectedAccount } = useContext<AuthData>(AuthContext);
  const [limit] = React.useState<number>(4);

  const [viewAll] = React.useState<boolean>(true);
  const {
    data: paginatedData,
    fetchNextPage,
    isSuccess,
    hasNextPage,
    isLoading,
    isFetching,
    isFetchingNextPage,
  } = useGetFundBackedGrantVestmentQuery({
    fundId: selectedAccount?.fundAccountId! || 0,
    limit: limit,
  });
  let myGrantVestments = useMemo<FundBackedGrantVestment[]>(
    () =>
      paginatedData ? paginatedData?.pages?.flatMap((item) => item.data) : [],
    [paginatedData]
  );

  const lastElementRef = useIntersectionObserver({
    isFetching,
    isLoading,
    fetchNextPage,
    hasNextPage,
  });
  const { data, isSuccess: isSuccessTotal } =
    useGetFundBackedGrantVestmentTotalQuery({
      fundId: (selectedAccount?.fundAccountId as number) || 0,
    });
  //   const { data: grantvestmentList } = useGetGrantVestmentsQuery({
  //     filters: {
  //       sort: "Newest",
  //       show: "All",
  //     },
  //   });
  //   const handleViewAll = () => {
  //     setViewAll(!viewAll);
  //   };
  return (
    <Layout>
      {() => (
        <>
          <Box sx={{
            m: { xs: 2, md: 5 }
          }}>
            <Grid
              sx={{ mb: 2, mt: 2, alignItems: "center" }}
              container
              spacing={2}
            >
              <Grid item xs={12} sm={12} sx={{ mb: 2 }}>
                <Typography variant="h3"
                  sx={{
                    color: "neutral.main",
                    fontSize: {
                      xs: '28px',
                      sm: '34px'
                    }
                  }}>
                  My GrantVestmentsᵀᴹ
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography variant="smallCopy">TOTAL VALUE</Typography>
                <Typography variant="h2" sx={{ color: primary[900] }}>
                  ${moneyFormat(isSuccessTotal ? data?.totalAmount : 0)}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={8}>
                <Button
                  onClick={() => navigate(GrantVestmentsHomePage)}
                  startIcon={<GrantVestmentsIcon />}
                  variant="contained"
                  color="primary"
                  size="large"
                >
                  Browse all GrantVestments
                </Button>
              </Grid>
            </Grid>
            <Divider
              sx={{ backgroundColor: warm[600], borderWidth: "1px", mt: 7 }}
            />
            <Box sx={{ mt: 4, display: "flex", alignItems: "center" }}>
              <Typography
                className="title"
                variant="subtitle2"
                sx={{ color: "neutral.main", mr: 3 }}
              >
                Backed projects{" "}
              </Typography>
              {/* until we get back section interested in */}
              {/* <Button
                onClick={handleViewAll}
                className="link"
                variant="text"
                color="primary"
                size="large"
              >
                {viewAll ? "View less" : "View all"}
              </Button> */}
            </Box>
            <Grid
              sx={{ mb: 2, mt: 2, alignItems: "center" }}
              container
              spacing={2}
            >
              {isLoading && (
                <Grid item xs={12} sm={10} textAlign={"center"} sx={{ m: 3 }}>
                  <CircularProgress color="primary" />
                </Grid>
              )}

              {isSuccess && (
                <Grid
                  sx={{ mb: 2, mt: 2, alignItems: "center" }}
                  container
                  spacing={2}
                >
                  {myGrantVestments && myGrantVestments.length > 0 ? (
                    myGrantVestments.map(
                      (item: FundBackedGrantVestment, index: number) => {
                        return (
                          <Grid key={index} item xs={12} sm={12} md={12}>
                            <FundBackedGrantVestmentCard
                              grantvestment={item?.grantVestment}
                              dpi={item.dpi}
                              grantVestmentRequestStatue={
                                item.grantVestmentRequestStatue
                              }
                              pendingAmount={item.pendingAmount}
                              approvedAmount={item.approvedAmount}
                              backedAmount={item.backedAmount}
                              totalDistributedAmount={
                                item.totalDistributedAmount
                              }
                            />
                          </Grid>
                        );
                      }
                    )
                  ) : (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography
                        variant="smallCopyBold"
                        sx={{
                          color: neutral[500],
                          fontWeight: "700",
                          pl: 4,
                        }}
                      >
                        You have no Backed projects.{" "}
                      </Typography>
                    </Box>
                  )}
                </Grid>
              )}
            </Grid>
            {viewAll && (
              <Box ref={lastElementRef}>
                {isFetchingNextPage && (
                  <Grid xs={12} textAlign={"center"} sx={{ m: 3 }}>
                    <CircularProgress color="primary" />
                  </Grid>
                )}
              </Box>
            )}
          </Box>
          {/* {
                        !viewAll && <>
                            <Box sx={{ p: 5, backgroundColor: warm[500] }}>
                                <Typography className="title" variant='subtitle2' sx={{ color: 'neutral.main', mb: 3 }} >
                                    You might also be interested in</Typography>
                                {
                                    grantvestmentList?.data &&
                                    <GrantVestmentsCard grantvestment={grantvestmentList?.data[0]} single={true} allContent={false} />
                                }


                            </Box>
                            <Box sx={{ p: 5 }}>
                            </Box>
                        </>
                    } */}
        </>
      )}
    </Layout>
  );
};

export default FundBackedGrantVestmentList;
